var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.11133 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#0039a7",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.5863 10.9791-.0435-.0435c-.4087-.4088-1.0749-.4097-1.4861.0012l-1.5999 1.6167c-.0842.0845-.2191.0879-.307.007l-2.243-2.0708c-.2179-.2013-.5013-.312-.7983-.312h-3.3366c-.0788 0-.1542.0301-.2111.084l-2.828 2.6852c-.4143.4146-.4428 1.0829-.0632 1.4898.2029.2176.4769.3374.7713.3374h.0052c.2921-.0015.5727-.1256.7667-.3377l1.9973-2.1137h.7149l-4.6611 5.2093h-2.87483c-.6815 0-1.24193.5096-1.27594 1.1601-.01809.3398.1008.6628.33462.9091.23042.243.55432.3822.88926.3822h4.28989c.0846 0 .1655-.035.2237-.0972l2.198-2.3463 1.8483 1.9329-.558 3.5662c-.1406.5908.1429 1.1926.6739 1.4301.1636.0735.3373.1103.5102.1103.186 0 .3711-.0426.5414-.1269.3291-.163.5657-.4611.6518-.8319l.9533-5.1133c.0184-.0993-.0132-.2017-.0849-.2731l-2.5442-2.5408 2.0212-2.0181 1.4089 1.4086c.3935.3935 1.0792.3935 1.4724 0l2.6435-2.6432c.1952-.1952.3028-.4551.3028-.7308-.0001-.2761-.1077-.5356-.3029-.7308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.2067 11.097c1.014 0 1.8386-.8245 1.8386-1.83852 0-1.01397-.8246-1.83856-1.8386-1.83856-1.0139 0-1.8385.82459-1.8385 1.83856 0 1.01402.8246 1.83852 1.8385 1.83852z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsFitness);
export default __webpack_public_path__ + "static/media/AmenitiesIconsFitness.97b2d89674eff69bacc448979c32e310.svg";
export { ForwardRef as ReactComponent };